/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { InitDialogViewService } from '@gh/common-shared';
import { DialogRouteSnapshot, EmptyDialogInput } from '@gh/core-ui';
import { MobileQrCodeDialogRestService } from './mobile-qr-code-dialog-rest.service';

@Injectable()
export class MobileQrCodeDialogBusinessService implements InitDialogViewService<EmptyDialogInput> {
  constructor(private restService: MobileQrCodeDialogRestService) {}

  initDialogView(route?: DialogRouteSnapshot<EmptyDialogInput>): any {
    return {
      qrCode: this.restService.getQRCode(),
    };
  }
}
